module.exports = __webpack_public_path__ + "img/stop-circle.c1d0b831.svg";